module.exports = __webpack_public_path__ + "static/media/logo-white.120550f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo/logo-white.svg
// module id = 389
// module chunks = 0